import React, { useState } from "react";
import { Form, Button, Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import SideBar from "../navigation/sidebar/SideBar";
import NavBar from "../navigation/topnav/NavBar";
import RowTitles from "../components/RowTitles";
import axios from "axios";
import Loader from "../gif/loader.gif";
import SmsTableComp from "../components/SmsTableComp";

const BulkSms = () => {
  //
  //let sms_api_link = process.env.REACT_APP_SMS_KEY;
  //
  const [members, setMembers] = useState([]);
  const [filters, setFilters] = useState({
    attendanceStatus: "never", // default value
    rating: 1, // default value
  });
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  //
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");
  //
  const getData = async (url) => {
    setLoading(true);
    try {
      const res = await axios.get(url, {
        validateStatus: function (status) {
          // Accept both 200 and 404 status codes as valid responses
          return (status >= 200 && status < 300) || status === 404;
        },
      });
      let retcode = res.data;
      setMembers([]);
      if (!(res.status === 404 && retcode.message === "No records found")) {
        setMembers(retcode);
      }
      //stop loading
      setLoading(false);
    } catch (error) {
      //stop loading
      setLoading(false);
      console.log("get messages error =>" + error);
    }
  };
  const handleApplyFilters = () => {
    console.log("Applied filters:", filters);
    let url;
    switch (filters.attendanceStatus) {
      case "never":
        //did not attanded in the last x sundays
        url = `https://ntcapi-a4fdbbdfb3gactbd.southafricanorth-01.azurewebsites.net/api/get-filters-didnotattend?top=${filters.rating}`;
        getData(url);
        break;
      case "once":
        //attanded once in the last x sundays
        url = `https://ntcapi-a4fdbbdfb3gactbd.southafricanorth-01.azurewebsites.net/api/get-filters-attendedonce?top=${filters.rating}`;
        getData(url);
        break;
      case "not":
        //never attanded
        url = `https://ntcapi-a4fdbbdfb3gactbd.southafricanorth-01.azurewebsites.net/api/get-filters-neverattended`;
        getData(url);
        break;
      case "all":
        //attanded all events
        url = `https://ntcapi-a4fdbbdfb3gactbd.southafricanorth-01.azurewebsites.net/api/get-filters-cleanattandance`;
        getData(url);
        break;
      default:
        break;
    }
  };
  const handleSendBulkSms = async (e) => {
    e.preventDefault();
    try {
      // Validate inputs before sending
      if (!file) {
        alert("Please select a file");
        return;
      }
      if (!message.trim()) {
        alert("Please enter a message");
        return;
      }
      // Create URL with query parameters
      // const url = new URL(
      //   "https://ntcapi-a4fdbbdfb3gactbd.southafricanorth-01.azurewebsites.net/api/send-bulk-sms"
      // );
      //
      setLoading(true);

      // Create FormData (even though we're doing a GET request)
      const formData = new FormData();
      formData.append("file", file);
      formData.append("message", message);

      // Special GET request with body using axios
      const response = await axios({
        method: "post",
        url: "https://ntcapi-a4fdbbdfb3gactbd.southafricanorth-01.azurewebsites.net/api/send-bulk-sms",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      //
      //console.log("Full response:", response);
      alert(response.data?.message || "SMS sent successfully!");
      setLoading(false);
      setShow(!show);
      //
    } catch (error) {
      alert("Failed sending Bulk Smses -- try again!");
      //console.error("Send bulk SMS error:", error);
      setLoading(true);
      setShow(!show);
    }
  };
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
  };
  const exportToTextFile = () => {
    // Extract valid 8-digit cell numbers (excluding empty/invalid entries)
    const cellNumbers = members
      .map((member) => (member.cell ? member.cell.trim() : "")) // Trim whitespace
      .filter((cell) => {
        // Check if cell is exactly 8 digits (no letters, symbols, or spaces)
        return /^\d{8}$/.test(cell);
      });
    // Join with newlines (or commas if you prefer)
    const content = cellNumbers.join("\n");
    // Create a Blob with the content
    const blob = new Blob([content], { type: "text/plain" });
    // Create a download link
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download =
      "cell numbers_" +
      filters.attendanceStatus +
      "_" +
      filters.rating +
      ".txt";
    // Trigger the download
    document.body.appendChild(link);
    link.click();
    // Clean up
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };
  const openModal = () => {
    exportToTextFile();
    setShow(!show);
  };

  const handleClose = () => setShow(false);
  const reloadTable = () => {};
  const handleAttendanceChange = (e) => {
    setFilters({
      ...filters,
      attendanceStatus: e.target.value,
    });
  };

  const handleRatingChange = (e) => {
    setFilters({
      ...filters,
      rating: parseInt(e.target.value),
    });
  };

  return (
    <div className="d-flex" style={{ backgroundColor: "#f1f5f7" }}>
      <SideBar />
      <div className="flex-grow-1">
        {/* Header */}
        <NavBar />
        <div className="container-fluid mt-4 ml-2 mr-2">
          <div className="row">
            <div className="col-md-4 p-3">
              <RowTitles
                title={"Dashboad"}
                child={"filter members attandance"}
              />
            </div>
            <div className="col-md-8 p-3 text-end"></div>
          </div>
          {/* filters */}
          <div className="container mb-4 bg-white p-2 rounded">
            <div className="row align-items-center">
              <div className="col-md-6">
                <div className="row">
                  <small className="mb-3 text-info">Apply filters :</small>
                  <div className="col-md-5">
                    <Form.Group controlId="attendanceFilter">
                      <Form.Label className="fs-6 text-muted">
                        Attendance status
                      </Form.Label>
                      <Form.Select
                        className="custom-select rounded-0"
                        value={filters.attendanceStatus}
                        onChange={handleAttendanceChange}
                      >
                        <option value="never">Never Attended</option>
                        <option value="once">Attended Once</option>
                        <option value="not">0 Attandance</option>
                        <option value="all">100% Attandance</option>
                      </Form.Select>
                    </Form.Group>
                  </div>
                  <div className="col-md-5">
                    {filters.attendanceStatus === "not" ||
                    filters.attendanceStatus === "all" ? null : (
                      <Form.Group controlId="numberFilter">
                        <Form.Label className="fs-6 text-muted">
                          Select weeks
                        </Form.Label>
                        <Form.Select
                          className="custom-select rounded-0"
                          value={filters.rating}
                          onChange={handleRatingChange}
                        >
                          {[1, 2, 3, 4, 5].map((num) => (
                            <option key={num} value={num}>
                              {num}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-md-6 d-flex flex-row-reverse">
                <Button
                  variant="info"
                  className="mt-3 rounded-0"
                  onClick={handleApplyFilters}
                >
                  Apply Filters
                </Button>
              </div>
            </div>
          </div>
          <div className="container mb-4 d-flex flex-row-reverse">
            <Button variant="success" className="rounded-0" onClick={openModal}>
              Bulk SMS {members.length} Members
            </Button>
          </div>
          {/* table */}
          {loading ? (
            <img src={Loader} alt="QR Code" width={"50"} height={"50"} />
          ) : (
            <SmsTableComp
              members={members && members}
              itemsPerPage={10}
              reloadTable={reloadTable}
            />
          )}
        </div>
      </div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Send BULK Sms</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container">
            <div className="card p-2">
              <div className="card-body">
                <p className="text-muted mb-4" style={{ fontStyle: "italic" }}>
                  Please browse a file saved in your downloads folder with the
                  name 'cell number_..' containing a list of all cell numbers to
                  sms
                </p>
                <div className="mb-4">
                  <label for="formFileSm" class="form-label">
                    Upload file containing cell numbers
                  </label>
                  <input
                    class="form-control form-control-sm"
                    id="formFileSm"
                    type="file"
                    onChange={handleFileChange}
                  />
                </div>

                {/* Tags section */}
                <div className="mb-4">
                  <label className="form-label">Type sms message</label>
                  <textarea
                    type="text"
                    className="form-control"
                    placeholder="Click to start typing..."
                    onChange={(e) => setMessage(e.target.value)}
                  />
                  <div className="mt-2">
                    <div className="d-flex flex-wrap gap-2"></div>
                  </div>
                </div>

                {/* Action buttons */}
                <div className="d-flex justify-content-between mt-4">
                  <button
                    type="button"
                    className={`btn btn-outline-secondary`}
                    onClick={() => exportToTextFile()}
                  >
                    Re- download file
                  </button>

                  <div>
                    {loading ? (
                      <img
                        src={Loader}
                        alt="QR Code"
                        width={"50"}
                        height={"50"}
                      />
                    ) : (
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleSendBulkSms}
                      >
                        Send SMS
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default BulkSms;
